import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import AccessControl from "../../../../../../HOC/AccessControl";

const Panel = ({ onSave, onDelete }) => {
  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}></div>
      <div className={styles.btns}>
        <AccessControl moduleCode="FvrVqN" requiredPrivilege="cifHqu">
          <button
            className={cn("button-stroke", styles.button)}
            onClick={onDelete}
            type="button"
          >
            Delete
          </button>
        </AccessControl>

        <div className={styles.btns}>
          <AccessControl moduleCode="FvrVqN" requiredPrivilege="cifHqu">
            <button
              className={cn("button", styles.button)}
              onClick={onSave}
              type="submit"
            >
              Save
            </button>
          </AccessControl>
        </div>
      </div>
    </div>
  );
};

export default Panel;
